module.exports = __webpack_public_path__ + "static/media/sophisticated-4.78202774.png";